import { createGetOptionsNoPropsFn } from '@common/selectOptions.services';
import { IOrganizationTypeOption } from './organizationType.models';

export const apiRoutes = {
  organizationTypes: '/Companies/OrganizationTypes/Options',
};

export const getOrganizationTypesAsync = createGetOptionsNoPropsFn<IOrganizationTypeOption>(
  apiRoutes.organizationTypes,
);
